import { render } from "./ProjectBoardingUpload.vue?vue&type=template&id=b85fe5fa&scoped=true"
import script from "./ProjectBoardingUpload.vue?vue&type=script&lang=js"
export * from "./ProjectBoardingUpload.vue?vue&type=script&lang=js"

import "./ProjectBoardingUpload.vue?vue&type=style&index=0&id=b85fe5fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85fe5fa"]])

export default __exports__